import { getAdapter } from '../../adapters/AdapterManager';
import MessageComposeAdapter from '../../adapters/MessageComposeAdapter';
import { ApiErrorCode } from '../ApiErrorCode';
import { ApiMethodCallback } from '../ApiMethod';
import { createErrorResult, createSuccessResult } from '../ApiMethodResponseCreator';
import { isFeatureEnabled } from 'owa-feature-flags';
import { SsoErrorCode } from 'owa-addins-sso';

export interface AddFileAttachmentFromBase64Args {
    base64String: string;
    name: string;
    isInline: boolean;
}

export default async function addFileAttachmentFromBase64AsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: AddFileAttachmentFromBase64Args,
    callback: ApiMethodCallback
) {
    if (!isFeatureEnabled('addin-attachmentApis')) {
        callback(createErrorResult(SsoErrorCode.OperationNotSupported));
        return;
    }
    const adapter: MessageComposeAdapter = getAdapter(hostItemIndex) as MessageComposeAdapter;
    try {
        const attachmentId = await adapter.addFileAttachmentFromBase64(
            data.base64String,
            data.name,
            data.isInline
        );
        if (!attachmentId) {
            callback(createErrorResult(ApiErrorCode.AttachmentUploadGeneralFailure));
        } else {
            callback(createSuccessResult(attachmentId));
        }
    } catch (err) {
        callback(createErrorResult(err.errorCode));
    }
}
